import { z } from 'zod';
import { SweetShopArticleRecommendationModelSchema } from './sweet-shop-article-recommendation-model';

export const SweetShopArticleModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
    description: z.any().optional().nullable(),
    category: z.object({
        uid: z.string(),
    }).optional().nullable(),
    tags: z.array(z.object({
        uid: z.string(),
    })).optional().nullable(),
    images: z.array(z.object({
        url: z.string(),
    })).optional().nullable(),
    price: z.number().optional().nullable(),
    weight: z.number().optional().nullable(),
    currency: z.object({
        abbreviation: z.string(),
    }).optional().nullable(),
    elements: z.array(
        z.object({
            name: z.string(),
            value: z.number(),
            meassure: z.string(),
        }),
    ).optional().nullable(),
    recommendations: z.array(
        SweetShopArticleRecommendationModelSchema,
    ).optional().nullable(),
});

export type SweetShopArticleModel
    = z.infer<typeof SweetShopArticleModelSchema>;
